export enum ApplicationModalPurchaseType {
  UnusedBoughtCertificates = 'unused-bought-certificates',
  ReissueCertificate = 'reissue-certificate',
  NewPayment = 'payment',
}

export const newPaymentPurchaseType = {
  type: ApplicationModalPurchaseType.NewPayment,
  text: 'make-new-payment',
};

export const reissuedCertificatesPurchaseType = {
  type: ApplicationModalPurchaseType.ReissueCertificate,
  text: 'select-revoked-cert',
};

export const unusedBoughtCertificatesPurchaseType = {
  type: ApplicationModalPurchaseType.UnusedBoughtCertificates,
  text: 'select-bought-cert',
};
